import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_arrow2",
  "use": "icon-add_arrow2-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add_arrow2\">\n\n   \n        <polygon id=\"icon-add_arrow2_Path-2\" points=\"29.7279624 65.4545455 58.2650543 88 149.250073 10.0948441 82.2312719 101.818182 132.327081 116.363636 15.2124712 151.724435\" />\n   \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol